import {memo} from 'react'
import {useTranslation} from 'react-i18next'

export const RowHead = memo(() => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>{t('username')}</th>
      <th className='td-order-7 text-center'>{t('Activities')}</th>
      <th>{t('kontrak-tanggal')}</th>
      <th>{t('Waktu')}</th>
    </tr>
  )
})
